import { useContext } from 'react'
import { SaleOrderViewContext } from '../Context'

const ViewModel = () => {

  const { isOpenViewModal, setIsOpenViewModal } = useContext(SaleOrderViewContext)

  const resetState = () => {

  }

  const handleClose = () => {
    setIsOpenViewModal(false)
    resetState()
  }

  

  const modalsRoot = document.getElementById('root-modals') || document.body


  return {
    modalsRoot,
    isOpenViewModal,
    handleClose
  }
}

export default ViewModel
